export function browserOrigin(): string {
  return window.location.origin
}
